// SPDX-FileCopyrightText: 2026 TRUMPF Laser SE
//
// SPDX-License-Identifier: LicenseRef-TRUMPF
import { skipToken, useQuery } from '@tanstack/react-query';
import { useAuthContext } from '@tls/auth';
import type { BannerDto } from 'model/Banner';
import { useTranslation } from 'react-i18next';
import type { UiVersionStatus } from 'utilities/uiVersion';

export type AppStatus = {
  banner: BannerDto | null;
  uiVersionStatus: UiVersionStatus;
};

export function getAppStatusQueryKey(appBaseUrl = '', language = 'en') {
  return ['app-status', appBaseUrl, language] as const;
}

export function useAppStatusData() {
  const { appBaseUrl } = useAuthContext();
  const { i18n } = useTranslation();

  return useQuery<AppStatus>({
    queryKey: getAppStatusQueryKey(appBaseUrl, i18n.resolvedLanguage),
    queryFn: skipToken,
  }).data;
}
